import { useTranslation } from "react-i18next";

import MessageDialog from "components/__reusable/MessageDialog";
import DialogActionButton from "components/__reusable/DialogActionButton";
import useAppSelector from "hooks/useAppSelector";
import useAppDispatch from "hooks/useAppDispatch";
import { resetErrorStatus } from "features/error/errorSlice";

const ErrorMessageDialog = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { error, message, title, buttonStyle } = useAppSelector((state) => state.error);

  const close = () => {
    dispatch(resetErrorStatus());
  };

  return error ? (
    <MessageDialog>
      <div className="flex flex-col items-center justify-center space-y-6 text-center">
        <h2 className="text-[28px] font-semibold leading-tight text-[#F24848]">
          {t(title || "_generic._error")}
        </h2>
        <pre className="whitespace-pre-wrap text-sm leading-7 text-[#333333]">
          {t(message)}
        </pre>
        <div className="w-full max-w-[180px]">
          <DialogActionButton
            label={t("_generic._close")}
            onClick={() => close()}
            variant={buttonStyle === "red" ? "danger" : "danger"}
          />
        </div>
      </div>
    </MessageDialog>
  ) : (
    <></>
  );
};

export default ErrorMessageDialog;
